import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../../App";
import "./NavigationBar.css";

const NavigationBar = () => {
  const [user, setUser] = useContext(UserContext);
  return (
    <div className="nav-bar-div">
      <header>
        <nav className="nav-bar">
          <h1 className="nav-logo">JC TRANSPORT</h1>
          <ul className="nav-links">
            <li className="m-right">
              <Link to="/home" className="nav-link">
                Home
              </Link>
            </li>
            <li className="m-right">
              <Link to="/destination" className="nav-link">
                Destination
              </Link>
            </li>
            <li className="m-right">
              <Link to="/blog" className="nav-link">
                Blog
              </Link>
            </li>
            <li className="m-right">
              <Link to="/contact" className="nav-link">
                Contact
              </Link>
            </li>
            {user.isLoggedIn ? (
              <li>
                <b>{user.name}</b>
              </li>
            ) : (
              <li className="nav-login-btn">
                <Link to="/login">
                  <span className="text-white">Login</span>
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </header>
    </div>
  );
};

export default NavigationBar;
